import type { MarkdownBuffer, MarkdownBufferItem } from './types';


export default function createMarkdownBuffer(): MarkdownBuffer {
  const markdownLinesPerActionPublicId: Record<string, MarkdownBufferItem[]> = {};

  return {
    append: entry => {
      const arr = Array.isArray(entry) ? entry : [entry];
      arr.forEach(entryToAppend => {
        const { actionPublicId, line } = entryToAppend;
        if (!Object.hasOwn(markdownLinesPerActionPublicId, actionPublicId)) {
          markdownLinesPerActionPublicId[actionPublicId] = [];
        }
        markdownLinesPerActionPublicId[actionPublicId].push(line);
      });
    },
    package: () => Object
      .values(markdownLinesPerActionPublicId)
      // add a line break at the end of each line
      .map(linesPerAction => linesPerAction.join('\n'))
      // add a line break and and empty line after each action's section
      .join('\n\n'),
  };
}
